import React from "react";
import { StyleSheet, css } from "aphrodite";
import { func } from "prop-types";
import SearchIcon from "@material-ui/icons/Search";

const styles = StyleSheet.create({
  inputSearch: {
    borderRadius: "21px !important",
  },
  input: {
    color: "#2CB96A",
    padding: 10,
    borderRadius: 4,
    textIndent: 10,
    zIndex: 30,
    borderWidth: 1,
    borderColor: "#F0F3F6",
    borderStyle: "solid",
    boxShadow: "none",
    display: "inline-block",
    boxSizing: "border-box",
    width: "100%",
    outline: "none",
    fontSize: "14px",
    fontFamily: [
      "Circular Std Book",
      "Roboto",
      "Segoe UI",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "Helvetica Neue",
      "sans-serif",
    ],
    backgroundColor: "#FFFFFF",
    ":hover": {
      // Overwrittes the different states of border
      borderColor: "#2CB96A",
    },
    ":focus": {
      // Overwrittes the different states of border
      borderColor: "#2CB96A",
      backgroundColor: "#2CB96A1A",
    },
    "::placeholder": {
      color: "#495057",
      opacity: 0.68,
    },
  },
  hasValue: {
    borderColor: "#2CB96A1A",
    backgroundColor: "#2CB96A1A",
  },
  disabled: {
    ":hover": {
      cursor: "not-allowed",
      borderColor: "#EFF0F2",
    },
  },

  icon: {
    position: "absolute",
    top: 5,
    padding: 5,
    height: 30,
    backgroundColor: "#5FB971",
    color: "#FFFFFF",
    borderRadius: "50%",
    width: 30,
    cursor: "pointer",
  },
  start: {
    left: 10,
  },
  startContainer: { paddingLeft: 35 },
  end: {
    right: 10,
  },
  endContainer: { paddingRight: 35 },
});

const InputContainer = (props) => {
  const {
    value,
    placeholder,
    startIcon,
    disabled,
    endIcon,
    className,
    isTextarea,
    ...otherProps
  } = props;
  const StartIcon = startIcon;
  const EndIcon = endIcon;
  const isSearchIcon = () => {
    if(startIcon === SearchIcon) {
      return true;
    } else if (endIcon === SearchIcon) {
      return true;
    }

    return false
  }
  return (
    <div style={{ position: "relative" }}>
      {isTextarea === true ?
        <textarea
          className={css(
            styles.input,
            props.value && styles.hasValue,
            startIcon && styles.startContainer,
            endIcon && styles.endContainer,
            disabled && styles.disabled,
            className
          )}
          rows={5}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          disabled={props.disabled}
          {...otherProps}
        /> :
        <input
          className={css(
            styles.input,
            isSearchIcon() && styles.inputSearch,
            props.value && styles.hasValue,
            startIcon && styles.startContainer,
            endIcon && styles.endContainer,
            disabled && styles.disabled,
            className
          )}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          disabled={props.disabled}
          {...otherProps}
        />
      }
      {startIcon && (
        <StartIcon
          onClick={props.onClickIcon}
          className={css(styles.icon, styles.start)}
        />
      )}
      {endIcon && (
        <EndIcon
          onClick={props.onClickIcon}
          className={css(styles.icon, styles.end)}
        />
      )}
    </div>
  );
};

InputContainer.propsTypes = {
  startIcon: func,
  endIcon: func,
};
InputContainer.defaultProps = {};

export default InputContainer;
